import React, { useEffect } from "react";
import { MenuItem, Select } from "@mui/material";
import { useModel } from "hooks/useModel";
import { useMetadataByCategory } from "components/summary/hooks";

const ChatAreaInputModelBtn = () => {
  const { model, setModel } = useModel("aichat");
  const data = useMetadataByCategory("AI_MODEL")?.data || [];

  useEffect(() => {
    if (!model) {
      setModel(data[data.length - 1]?.value || "");
    }
  }, [model, data, setModel]);

  return (
    <>
      <Select
        value={model}
        onChange={(e) => setModel(e.target.value)}
        displayEmpty
        size="small"
        sx={{
          height: "28px",
        }}
        renderValue={(selected) => {
          const option = data.find((o) => o.value === selected);
          return option ? option.value : selected;
        }}
        MenuProps={{
          anchorOrigin: {
            vertical: "top",
            horizontal: "left",
          },
          transformOrigin: {
            vertical: "bottom",
            horizontal: "left",
          },
          sx: {
            zIndex: (theme) => theme.zIndex.modal + 3,
          },
          PaperProps: {
            sx: {
              zIndex: (theme) => theme.zIndex.modal + 3,
            },
          },
        }}
      >
        {data.map((option) => (
          <MenuItem
            key={option.id}
            value={option.value}
            sx={{ zIndex: (theme) => theme.zIndex.modal + 2 }}
          >
            <div>
              <div style={{ fontWeight: 600 }}>{option.value}</div>
              <div style={{ fontSize: 12, color: "#888" }}>{option.description}</div>
            </div>
          </MenuItem>
        ))}
      </Select>
    </>
  );
};

export default ChatAreaInputModelBtn;
